import { createSlice } from "@reduxjs/toolkit";

const goalSlice = createSlice({
    name: "goals",
    initialState: {},
    reducers: {
        registerGoal: (state, action) => {
            const goal = action.payload;
            if (!goal?.id) return;

            if (!state[goal.id]) {
                state[goal.id] = goal;
            } else {
                console.warn(
                    `⚠️ Goal ${goal.id} already exists — skipping overwrite.`
                );
            }
        },

        bulkRegisterGoals: (state, action) => {
            action.payload.forEach((goal) => {
                if (!goal?.id) return;

                if (!state[goal.id]) {
                    state[goal.id] = goal;
                } else {
                    console.warn(
                        `⚠️ Goal ${goal.id} already exists — skipping overwrite.`
                    );
                }
            });
        }
    }
});

export const { registerGoal, bulkRegisterGoals } = goalSlice.actions;
export default goalSlice.reducer;
